const resource = {
    resource_identifier_in_use: 'API 識別碼 {{indicator}} 已經被使用',
    cannot_delete_management_api: '無法刪除 Logto 管理 API。',
    cannot_modify_management_api: '無法修改 Logto 管理 API。',
};
export default Object.freeze(resource);
